import { IonCol, IonRow } from "@ionic/react";

interface EventSummaryCardProps {
    eventName: string;
    dateRange: string;
    onClick: () => void;
}

const EventSummaryCard: React.FC<EventSummaryCardProps> = ({ eventName, dateRange, onClick }) => {
    return (
        <div className="mb-2">
            <IonRow className="mx-0">
                <IonCol className="ion-no-padding">
                    <div
                        onClick={onClick}
                        role="button"
                        tabIndex={0}
                        aria-label="Open event info"
                        className="event-summary-card"
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                onClick();
                            }
                        }}>
                        <div className="event-summary-card__icon">
                            <span aria-hidden="true" className="event-summary-card__icon-emoji">
                                📅
                            </span>
                        </div>
                        <div className="event-summary-card__text">
                            <p className="text-info m-0 event-summary-card__date">{dateRange}</p>
                            <p className="text-info m-0 event-summary-card__name">{eventName}</p>
                        </div>
                    </div>
                </IonCol>
            </IonRow>
        </div>
    );
};

export default EventSummaryCard;
